import { BlankModal, ModalBody, ModalFooter, HStack, useToast, Button, Text } from '@cad-arc';
import { useCallback } from 'react';
import { useFullscreenModalControls } from '../modals/context/modal-context-provider';
import { UnitInEmergencyInfo } from './types';
import { useUnitEmergency } from './use-unit-emergency';

export type EndUnitEmergencyModalComponentType = typeof EndUnitEmergencyModal;

export function EndUnitEmergencyModal({ unit }: { unit: UnitInEmergencyInfo }) {
    const { endUnitEmergency, endUnitEmergencyMutation } = useUnitEmergency();
    const modalControls = useFullscreenModalControls();
    const toast = useToast();

    const endEmergency = useCallback(() => {
        endUnitEmergency(unit.unitId)?.then(() => {
            toast({
                status: 'default',
                description: `Ended emergency for unit ${unit.callSign}`,
            });
        });
    }, [toast, endUnitEmergency, unit]);

    if (!unit) {
        return null;
    }

    return (
        <BlankModal isOpen onClose={() => modalControls.close()}>
            <ModalBody>
                <Text>End emergency for unit {unit.callSign}?</Text>
            </ModalBody>
            <ModalFooter>
                <HStack width="100%" justifyContent="flex-end" gap={5}>
                    <Button
                        onClick={() => modalControls.close()}
                        isDisabled={endUnitEmergencyMutation.isLoading}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={endEmergency}
                        variant="solid"
                        isLoading={endUnitEmergencyMutation.isLoading}
                    >
                        Confirm
                    </Button>
                </HStack>
            </ModalFooter>
        </BlankModal>
    );
}
